import { useEffect, useState, useContext } from "react";
import $ from "jquery";
import {Accordion,Card,ListGroup,Button,Modal,Form} from 'react-bootstrap';
import {BsFillPencilFill,BsFillHouseDoorFill,BsPeople,BsFileEarmarkRuledFill,BsEye} from 'react-icons/bs';
import {
  useNavigate
  } from "react-router-dom";
  import Spinner from 'react-bootstrap/Spinner';
  import UserContext from "../../contexts/UserContext";

const Profile = () => {
  const navigate = useNavigate();

const [show, setShow] = useState(false);
const [dateShow, setDateShow] = useState(false);
const [addShow, setAddShow] = useState(false);
const[currentProfile,setCurrentProfile] = useState({});
const [blocks,setBlocks] = useState([]);
const [flatForAblock,setAflats] = useState([]);
const [flatForBblock,setBflats] = useState([]);
const [flatForCblock,setCflats] = useState([]);
const [flatForDblock,setDflats] = useState([]);
const [others,setOthers] = useState([]);
const[totalTakhmeen, setTotalTakhmeen] = useState(null); 

const handleClose = () => setShow(false);
const handleDateClose = () => setDateShow(false);
const handleAddClose = () => setAddShow(false);
const {user,setUser} = useContext(UserContext);
const [isLoading, setLoading] = useState(true);

  async function getDataForUser(){
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/getUsersSession",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response && response.user){
           setUser(response.user);
           setLoading(false)
        }else{
          setUser(null)
          navigate("/login");
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
  }

async function getUser(userId){
  await $.ajax({
    type:"GET",
    url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
     success :async function(response){
      if(response && response.user){
        setUser(response.user);
        if(!(response.user.role==='admin')){
          setLoading(false);
        }
      }else{
        setUser(null);
        navigate("/login",{state: { message: response.message }})
      }

    },
    error: function(err){
        console.log("error")
        console.log(err)
        setLoading(false);
    }
})
}

function getData(){
    $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getDatas",
        xhrFields: {
            withCredentials: true  // Include cookies
          },
          crossDomain: true, 
         success : function(response){
          if(response.message  && response.message.includes("Error in auth")){
            navigate("/login",{state: { message: response.message }});
          }
            setBlocks(['A BLOCK','B BLOCK','C BLOCK','D BLOCK','Others']);
            setAflats(response.blockA);
            setBflats(response.blockB);
            setCflats(response.blockC);
            setDflats(response.blockD);
            setOthers(response.others)
            setLoading(false);
        },
        error: function(err){
            console.log("error")
            console.log(err)
            setLoading(false);
        }
    })
}


function editProfile(profile){
  setShow(true);
  setCurrentProfile(profile);
}

function updateProfile(e){
    e.preventDefault();
  const profile={};
  profile.sabeel=e.target.sabeel.value;
  profile.name=e.target.name.value;
  profile.hof=e.target.its.value;
  profile.block=e.target.flat.value;
  profile.members=e.target.count.value;
  $.ajax({
    type:"PUT",
    url:process.env.REACT_APP_API_URL+"/updateProfile",
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
    data:{profile},
    dataType: 'json',
     success : function(response){
      if(response.message  && response.message.includes("Error in auth")){
        navigate("/login",{message:response.message});
      }
        getData();
    },
    error: function(err){
        console.log("error")
        console.log(err)
    }
})

handleClose();
}

const showDates = (profile)=>{
  setDateShow(true)
  setCurrentProfile(profile)
}

const addNewUser = (e) => {
  const profile={};
  profile.sabeel=e.target.sabeel.value;
  profile.name=e.target.name.value;
  profile.hof=e.target.its.value;
  profile.block=e.target.flat.value;
  profile.members=e.target.count.value;
  $.ajax({
    type:"POST",
    url:process.env.REACT_APP_API_URL+"/newProfile",
    xhrFields: {
        withCredentials: true  // Include cookies
      },
      crossDomain: true, 
    data:{profile},
    dataType: 'json',
     success : function(response){
      if(response.message  && response.message.includes("Error in auth")){
        navigate("/login",{message:response.message});
      }
        // getData();
    },
    error: function(err){
        console.log("error")
        console.log(err)
    }
  })
}

useEffect(() => {
  if (user && user.role === 'admin') {
    getData();
  }else{
    try{
    if(!user && localStorage.getItem('userSession')){
      getUser(JSON.parse(localStorage.getItem('userSession')))
    }else{
      if(!user){
        getDataForUser();
      }else{
        setLoading(false)
      }
    }
  }catch(e){
    if(!user){
      getDataForUser();
    }else{
      setLoading(false)
    }
  }
  }
}, [user]);

const calculateTotalTakhmeen=(profile)=>{
      let totalAmount = 0;
      profile.takhmeen.map((takhmeen)=>{
          totalAmount = takhmeen.amount + totalAmount;
      })
      setTotalTakhmeen(totalAmount)
  
}

const AccordionBlock = (block) => {
  const AccordionBlockDesign = (
  <>
      <Accordion.Item eventKey={block}>
              <Accordion.Header>{block.data === 'Others'?'Aamil Saab & Atraaf':block.data}</Accordion.Header>
              
              <Accordion.Body>
                  <ListGroup>
                      {
                         (block.data==='A BLOCK')?
                          (flatForAblock.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item>{flat.hof}</ListGroup.Item>
                                  <ListGroup.Item className='d-flex justify-content-between'>
                                    <div><BsFillHouseDoorFill />  {flat.block} </div>
                                    <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })):(block.data==='B BLOCK')?
                          (flatForBblock.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item>{flat.hof}</ListGroup.Item>
                                  <ListGroup.Item className='d-flex justify-content-between'>
                                    <div><BsFillHouseDoorFill />  {flat.block} </div>
                                    <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })):(block.data==='C BLOCK')?
                          (flatForCblock.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item>{flat.hof}</ListGroup.Item>
                                  <ListGroup.Item className='d-flex justify-content-between'>
                                    <div><BsFillHouseDoorFill />  {flat.block} </div>
                                    <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })):(block.data==='D BLOCK')?
                          (flatForDblock.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item>{flat.hof}</ListGroup.Item>
                                  <ListGroup.Item className='d-flex justify-content-between'>
                                    <div><BsFillHouseDoorFill />  {flat.block} </div>
                                    <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })):(block.data==='Others')?
                          (others.map((flat,i)=>{
                              return <Card key={i} className="mt-3 mx-3">
                              <Card.Header className='d-flex justify-content-between'>
                                <div><BsFileEarmarkRuledFill className="svg-color"/> {flat.sabeel}</div>
                                <div className='d-inline' onClick={()=>{editProfile(flat)}}><BsFillPencilFill className="svg-color"/></div>
                                </Card.Header>
                              <ListGroup>
                                  <ListGroup.Item>{flat.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ')}</ListGroup.Item>
                                  <ListGroup.Item>{flat.hof}</ListGroup.Item>
                                  <ListGroup.Item className='d-flex justify-content-between'>
                                    <div><BsFillHouseDoorFill />  {flat.block} </div>
                                    <div className='d-inline'><BsPeople className='mx-1' />{flat.members}</div>
                                  </ListGroup.Item>
                                  {(flat.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
                                    <div>Tiffin Taken : {flat.tiffin.length === 1 &&  typeof flat.tiffin[0] === 'object' && flat.tiffin[0][new Date().getFullYear()]? flat.tiffin[0][new Date().getFullYear()]['total'] : flat.tiffin.length} days ( {new Date().getFullYear()} )</div>
                                    <div onClick={()=>{showDates(flat)}}><BsEye /></div>
                                    </ListGroup.Item>):null}
                              </ListGroup>
                              </Card>
                          })):null
                          
                      }
                  </ListGroup>
              </Accordion.Body>
      </Accordion.Item>
  </>
  )
  return AccordionBlockDesign;
}

const TiffinDates = ({data}) => {
  const monthOptions = { month: 'long' };
  const design = (
  <>
  <Accordion defaultActiveKey={new Date().getFullYear().toString() ? new Date().getFullYear().toString():(new Date().getFullYear()-1).toString()}>
        {Object.keys(data).map(year => (
          <div>
            {console.log(data[year])}
            <Accordion.Item eventKey={year}>
            <Accordion.Header>
              <span>{year} - {data[year].total} days</span>
            </Accordion.Header>
            <Accordion.Body>
              <Card.Body className="p-3 pb-1">
                {Object.keys(data[year].months).map(monthKey => {
                  const date = new Date(`${year}-${monthKey}-01`.split("/")[0]);
                  const month = date.toLocaleString(undefined, monthOptions);

                  return (
                    <>
                    <div key={monthKey}>
                      <p>{month}: {data[year].months[monthKey].count} days</p>
                    </div>
                    <hr/>
                    {
                    month===new Date().toLocaleString(undefined, monthOptions)?
                    <div className="dateCard">
                      <h6>Dates of tiffin taken this month</h6>
                      {
                        data[year].months[monthKey].dates.map((currDate,i)=> {if(currDate!="First"){return <p key={i}>{new Date(currDate).toDateString()}</p>}})
                      }
                    </div>:null
                    }
                    </>
                  );
                })}
              </Card.Body>
            </Accordion.Body>
            </Accordion.Item>
          </div>
        ))}
      </Accordion>
  </>)
  return design
}

const TakhmeenCard = ({profile}) => {
  calculateTotalTakhmeen(profile);
  const design = (
    <>
      <Card className="mt-3 mx-3">
          <Card.Header className='d-flex justify-content-between'>
          <div><BsFileEarmarkRuledFill className="svg-color"/> Takhmeen Details</div>
          </Card.Header>
              {profile && profile.takhmeen && profile.takhmeen.length>0?
              (
                  profile.takhmeen.map((currTakhmeen) => {
                      return (
                              currTakhmeen.year==='till1444'?
                              <ListGroup>
                                  <ListGroup.Item>Year : Till 1444H </ListGroup.Item>
                                  <ListGroup.Item>Hub Due : {currTakhmeen.amount}</ListGroup.Item>
                              </ListGroup>:
                              <ListGroup>
                                  <ListGroup.Item>Year : {currTakhmeen.year}  </ListGroup.Item>
                                  <ListGroup.Item>Takhmeen Amount : {currTakhmeen.amount}</ListGroup.Item>
                              </ListGroup>
                          )
                  })
              ):null
              }
          <ListGroup>
              <ListGroup.Item className="totalHub" style={{backgroundColor: '#402E32',fontWeight:'bold',color: 'white!important' }}>
                  Total Hub Due : {totalTakhmeen - profile.hubPaid}
              </ListGroup.Item>
          </ListGroup>      
      </Card>
    </>
  )
  return design;
}

const profileDesign = (
    <>
    {
      (user && (user.role==='admin'))?
      (
        <div className="mt-3">
        <Accordion>
      {
          blocks.map((block,index)=>{
              return <AccordionBlock data={block} key={index}/>
          })
      }
      </Accordion>
      
      <div className='d-flex mx-1 mt-3 justify-content-end'>
            <Button className='w-100' style={{backgroundColor:'#884A39',borderColor:'#884A39'}} onClick={()=>{setAddShow(true)}}> Add New + </Button>
      </div>
      </div>
      ):
      (
      <div>
        <Card className="mt-3 mx-3">
        <Card.Header className='d-flex justify-content-between'>
          <div><BsFileEarmarkRuledFill className="svg-color"/> {user?user.sabeel:null}</div>
          </Card.Header>
        <ListGroup>
            <ListGroup.Item>{(user&&user.name)?user.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' '):null}</ListGroup.Item>
            <ListGroup.Item>{user?user.hof:null}</ListGroup.Item>
            <ListGroup.Item className='d-flex justify-content-between'>
              <div><BsFillHouseDoorFill />  {user?user.block:null} </div>
              <div className='d-inline'><BsPeople className='mx-1' />{user?user.members:null}</div>
            </ListGroup.Item>
            {(user && user.tiffin&&user.tiffin.length>0)?(<ListGroup.Item className='d-flex justify-content-between'>
              <div>Tiffin Taken : {user.tiffin.length === 1 &&  typeof user.tiffin[0] === 'object' ? user.tiffin[0][new Date().getFullYear()]['total'] : user.tiffin.length} days ( {new Date().getFullYear()} )</div>
              <div onClick={()=>{showDates(user)}}><BsEye /></div>
              </ListGroup.Item>):null}
        </ListGroup>
        </Card>
        {user && user.takhmeen?<TakhmeenCard profile = {user}/>:null}
      </div>
      )
    }

    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="menuForm" onSubmit={updateProfile}>
                <Form.Group className="mb-3">
                  <Form.Label>Sabeel</Form.Label>
                  <Form.Control name="sabeel" type="text" defaultValue={currentProfile.sabeel?currentProfile.sabeel:null} placeholder="Sabeel" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name="name" type="text" defaultValue={currentProfile.name?currentProfile.name:null} placeholder="Name" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>ITS</Form.Label>
                  <Form.Control name="its" type="text" defaultValue={currentProfile.hof?currentProfile.hof:null} placeholder="ITS" required/>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Flat No</Form.Label>
                  <Form.Control name="flat" type="text" defaultValue={currentProfile.block?currentProfile.block:null} placeholder="Flat No" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Members Count</Form.Label>
                  <Form.Control name="count" type="text" defaultValue={currentProfile.members?currentProfile.members:null} placeholder="Members Count" />
                </Form.Group>
                
            <Button variant="primary" type="submit">Submit</Button>
          </Form>
          </Modal.Body>
      </Modal>
        
      <Modal show={dateShow} onHide={handleDateClose}>
        <Modal.Header closeButton>Sabeel: {currentProfile.sabeel}</Modal.Header>
        <Modal.Body>
          {
          (currentProfile.tiffin && typeof currentProfile.tiffin[0] === 'object')?
          <TiffinDates data={currentProfile.tiffin[0]}/>
          :
          currentProfile.tiffin?
          currentProfile.tiffin.map((dates)=>{
            const dateCurrent = dates.split("T")[0].split("-");
            const finalDate = new Date(Number(dateCurrent[0]),Number(dateCurrent[1]-1),Number(dateCurrent[2]));
          return <p>{finalDate.toDateString()}</p>
          }):null
          }
        </Modal.Body>
      </Modal>

      <Modal show={addShow} onHide={handleAddClose}>
        <Modal.Header closeButton>
          <Modal.Title>New Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form id="menuForm" onSubmit={addNewUser}>
                <Form.Group className="mb-3">
                  <Form.Label>Sabeel</Form.Label>
                  <Form.Control name="sabeel" type="number"  placeholder="Sabeel" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control name="name" type="text"  placeholder="Name" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>ITS</Form.Label>
                  <Form.Control name="its" type="number" placeholder="HOF ITS" required />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Flat No</Form.Label>
                  <Form.Control name="flat" type="text" placeholder="Flat No" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Members Count</Form.Label>
                  <Form.Control name="count" type="number" placeholder="Members Count" />
                </Form.Group>
                
            <Button variant="primary" type="submit">Submit</Button>
          </Form>
          </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleClose}> Save Changes</Button>
        </Modal.Footer> */}
      </Modal>
    </>
);
return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
</Spinner><br/>
<span style={{marginLeft:'-10px'}}>Loading...</span></div>: profileDesign;
}

export default Profile;